import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import type { ApprovalRequest } from "../types";

interface Props {
  request: ApprovalRequest;
  onDecision: (decision: "approved" | "denied", scope: "once" | "chat") => Promise<void>;
}

export function ApprovalCard({ request, onDecision }: Props) {
  const [busy, setBusy] = useState(false);

  async function decide(decision: "approved" | "denied", scope: "once" | "chat") {
    if (busy) return;
    setBusy(true);
    try {
      await onDecision(decision, scope);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="approval-card" role="alert">
      <header className="approval-card__header">
        <AlertTriangle size={14} />
        <span>{request.agent} wants to run:</span>
        <code className="approval-card__command">{request.command}</code>
      </header>
      <div className="approval-card__meta">
        Pack: <strong>{request.pack}</strong> · Rule: <strong>{request.rule}</strong>
      </div>
      <p className="approval-card__reason">{request.reason}</p>
      <div className="approval-card__actions">
        <button type="button" disabled={busy} onClick={() => void decide("approved", "once")}>
          Approve once
        </button>
        <button type="button" disabled={busy} onClick={() => void decide("approved", "chat")}>
          Always allow in this chat
        </button>
        <button
          type="button"
          disabled={busy}
          className="danger"
          onClick={() => void decide("denied", "once")}
        >
          Deny
        </button>
      </div>
    </div>
  );
}
